
import React from 'react';

export const DealsSection: React.FC = () => {
  const deals = [
    {
      id: 1,
      title: 'Flash Sale',
      subtitle: 'Up to 70% Off',
      description: 'Limited time offer on selected items',
      image: 'https://public.readdy.ai/ai/img_res/3490c14909c12369790ab3a71757af0f.jpg',
      color: 'from-red-500 to-orange-500'
    },
    {
      id: 2,
      title: 'New Arrivals',
      subtitle: '25% Off',
      description: 'Fresh styles for the season',
      image: 'https://readdy.ai/api/search-image?query=New%20arrival%20fashion%20items%20with%20modern%20clothing%20and%20accessories%2C%20fresh%20spring%20colors%2C%20trendy%20retail%20display%2C%20contemporary%20fashion%20photography%2C%20clean%20and%20stylish%20composition&width=160&height=120&seq=deal2&orientation=landscape',
      color: 'from-blue-500 to-purple-500'
    }
  ];

  return (
    <section className="px-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-800">Special Deals</h2>
        <button className="text-emerald-500 text-sm font-medium">View All</button>
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        {deals.map((deal) => (
          <div
            key={deal.id}
            className="relative h-32 rounded-2xl overflow-hidden shadow-sm"
          >
            <img
              src={deal.image}
              alt={deal.title}
              className="w-full h-full object-cover object-top"
            />
            <div className={`absolute inset-0 bg-gradient-to-r ${deal.color} opacity-80`}></div>
            <div className="absolute inset-0 p-4 flex flex-col justify-center">
              <h3 className="text-white font-bold text-sm mb-1">{deal.title}</h3>
              <p className="text-white text-lg font-bold mb-1">{deal.subtitle}</p>
              <p className="text-white/90 text-xs">{deal.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
